// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"158":"labels","496":"campaigns","644":"account","721":"inbox","806":"user","877":"phone-number-settings"}[chunkId] + "." + {"158":"1b4cc40ce89b4d4f3612","496":"74b6a61fa82177cb14fa","644":"3649d3eb5143d72cccd1","721":"eefdc511b99b52c48381","806":"1b9a94095a939832e8fb","877":"e8de7e98049c5fd17e1b"}[chunkId] + ".js";
};